<app-table-generic
  [table]="tableService.tableSubject"
  [data]="(tableService.dataTableGenericSubject$ | async)?.data || []"
  (onLazyLoad)="tableService.onLoadRecords($event, 2)"
  (onSelected)="tableService.onSelected($event)"
  [totalRecords]="
    (tableService.dataTableGenericSubject$ | async)?.totalRecords ?? 0
  "
  [showButtonCleanFilters]="true"
>
  <p-button
    (click)="tableService.onExportSelectedExcel()"
    variant="outlined"
    styleClass="ml-2 h-[32px] justify-center border-primary span-p-badge-primary "
    [disabled]="
      ((tableService.dataTableGenericSubject$ | async)?.data?.length ?? 0) === 0
    "
  >
    <i class="pi pi-file-excel"></i>
  </p-button>
</app-table-generic>
